document.addEventListener("DOMContentLoaded", function () {
  const purchaseDate = new Date();
  const shippingDate = calculateShippingDate(purchaseDate);
  document.getElementById("purchase-date").innerHTML = formatDate(purchaseDate);
  document.getElementById("shipping-date").innerHTML = formatDate(shippingDate);
});

function calculateShippingDate(purchaseDate) {
  const shippingDate = new Date(purchaseDate);
  const shippingDays = 3;

  let i = 0;

  while (i < shippingDays) {
    shippingDate.setDate(shippingDate.getDate() + 1);
    if (isBusinessDay(shippingDate)) {
      i++;
    }
  }
  return shippingDate;
}

function isWeekday(date) {
  const dayOfWeek = date.getDay();
  return dayOfWeek >= 1 && dayOfWeek <= 5;
}

function isWeekend(date) {
  const dayOfWeek = date.getDay();
  return dayOfWeek == 1 && dayOfWeek == 6;
}

function isBusinessDay(date) {
  return isWeekday(date) && !isHoliday(date);
}

function isHoliday(date) {
  //祝日・ショップ休日設定
  const holidays = [
    { start: new Date(2024, 7, 10), end: new Date(2024, 7, 16) }, // お盆休み（8月10日〜8月16日）
    { start: new Date(2024, 11, 30), end: new Date(2025, 0, 3) }, // 正月休み（12月31日〜1月3日）
    { start: new Date(2024, 1, 12), end: new Date(2024, 1, 12) },
    { start: new Date(2024, 1, 23), end: new Date(2024, 1, 23) },
    { start: new Date(2024, 2, 20), end: new Date(2024, 2, 20) },
    { start: new Date(2024, 3, 29), end: new Date(2024, 3, 29) },
    { start: new Date(2024, 4, 3), end: new Date(2024, 4, 6) },
    { start: new Date(2024, 6, 15), end: new Date(2024, 6, 15) },
    { start: new Date(2024, 7, 11), end: new Date(2024, 7, 12) },
    { start: new Date(2024, 8, 16), end: new Date(2024, 8, 16) },
    { start: new Date(2024, 8, 22), end: new Date(2024, 8, 23) },
    { start: new Date(2024, 9, 14), end: new Date(2024, 9, 14) },
    { start: new Date(2024, 10, 3), end: new Date(2024, 10, 4) },
    { start: new Date(2024, 10, 23), end: new Date(2024, 10, 23) },
  ];
  const targetDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  return holidays.some((holiday) => {
    return targetDate >= holiday.start && targetDate <= holiday.end;
  });
}

function formatDate(date) {
  const month = date.getMonth() + 1;
  const days = date.getDate();
  const day = ["日", "月", "火", "水", "木", "金", "土"][date.getDay()];
  return month + "月" + days + "日" + "(" + day + ")";
}
